<div [ngClass]="{'d-none': !isUpcomingRemindersExist}" class="subtitle-1--weight-regular">
    Upcoming (in the next 48 hours)
</div>
<div [ngClass]="{'d-none': !isUpcomingRemindersExist}" class="reminders-container">
    <div class="card">
        <div class="card-body px-0 py-2">
            <div class="upcoming-reminder-card-container pr-1">
                <app-upcoming-reminders-card *ngFor="let rem of reminders" [reminder]="rem"></app-upcoming-reminders-card>           
            </div>
        </div>
    </div>
</div>
